import { useCookies } from 'react-cookie';
import { getTranslation, type PortalLocale } from '@worldcoo/monolith/portals';
import { useRouter } from '@tanstack/react-router';
import { i18n } from '@lingui/core';
import { usePortalContext } from './use-portal-context';

export { getTranslation, type I18n } from '@worldcoo/monolith/portals';

export function useTranslation() {
	const [, setCookie] = useCookies(['language']);
	const { locale } = usePortalContext();
	const router = useRouter();

	const changeLanguage = (lang: PortalLocale) => {
		loadLandingTranslation(lang);
		setCookie('language', lang, { path: '/' });
		router.invalidate();
	};

	return { i18n: getTranslation(locale), language: locale, changeLanguage };
}

export const landingLocales = ['es', 'en', 'ca', 'it'] as const;
export type LandingLocale = (typeof landingLocales)[number];

export async function loadLandingTranslation(locale: PortalLocale) {
	const landingLocale = landingLocales.find((l) => l === locale) ?? 'es';
	const { messages } = await import(`../locales/${landingLocale}.po`);
	i18n.loadAndActivate({ locale: landingLocale, messages });
	return i18n;
}
